export enum NotificationType {
    None = 0,
    App,
    Email,
}

export const NotificationTypeTranslation: Partial<Record<NotificationType, string>> = {
    [NotificationType.App]: "Aplikacija",
    [NotificationType.Email]: "E-pošta",
};

export const notificationTypes: Record<string, { value: number; label: string }> = {
    Email: {
        value: NotificationType.Email,
        label: "Email",
    },
    Application: {
        value: NotificationType.App,
        label: "Aplikacija",
    },
};

export enum NotificationSource {
    None = 0,
    Notification,
    Alarm,
    Record,
    News,
    Advice,
    Education,
    PlantProtection,
    Manifestation,
}

export const NotificationSourceTranslation: Partial<Record<NotificationSource, string>> = {
    [NotificationSource.Notification]: "Poruke",
    [NotificationSource.Alarm]: "Alarmi",
    [NotificationSource.Record]: "Evidencije",
    [NotificationSource.News]: "Vijesti",
    [NotificationSource.Advice]: "Savjeti",
    [NotificationSource.Education]: "Edukacije",
    [NotificationSource.PlantProtection]: "Preporuke o zaštiti bilja",
    [NotificationSource.Manifestation]: "Manifestacije",
};

export enum NotificationPriority {
    None = 0,
    Information,
    Important,
    Critical,
}

export const NotificationPriorityColorTranslation: Partial<Record<NotificationPriority, string>> = {
    [NotificationPriority.Information]: "--color-primary-green",
    [NotificationPriority.Important]: "--color-secondary-green",
    [NotificationPriority.Critical]: "--color-secondary-red",
};

export const NotificationPriorityTranslation: Partial<Record<NotificationPriority, string>> = {
    [NotificationPriority.Information]: "Informacija",
    [NotificationPriority.Important]: "Važna obavijest",
    [NotificationPriority.Critical]: "Kritična obavijest",
};

export enum NotificationSeverity {
    None = 0,
    Notice,
    Announcement,
    Warning,
    Reminder,
    Call,
}

export const NotificationSeverityTranslation: Partial<Record<NotificationSeverity, string>> = {
    [NotificationSeverity.Notice]: "Obavijest",
    [NotificationSeverity.Announcement]: "Najava",
    [NotificationSeverity.Warning]: "Upozorenje",
    [NotificationSeverity.Reminder]: "Podsjetnik",
    [NotificationSeverity.Call]: "Poziv",
};

export enum SendingEntity {
    None = 0,
    Administration,
    RegionalService,
}

export const NotificationSendingEntityTranslation: Partial<Record<SendingEntity, string>> = {
    [SendingEntity.Administration]: "Uprava",
    [SendingEntity.RegionalService]: "Područna služba",
};

export enum BoolArrayFilter {
    False = 1,
    True = 2,
}

export const IsSharedTranslation: Record<BoolArrayFilter, string> = {
    [BoolArrayFilter.False]: "Ne",
    [BoolArrayFilter.True]: "Da",
};

export const IsNotificationReadTranslation: Record<BoolArrayFilter, string> = {
    [BoolArrayFilter.False]: "Nepročitano",
    [BoolArrayFilter.True]: "Pročitano",
};
